import React, { useState, useEffect } from "react";
import cx from "classnames";
import { Element as ScrollElement } from "react-scroll";
import { Image } from "src/components/image";
import { BlockCopy } from "src/components/block-copy";
import styles from "./content-module.module.css";

interface ProductMedia {
  _key: string;
  alt?: string;
  asset?: {
    _id: string;
  };
  image?: {
    asset: {
      _id: string;
      url: string;
    };
  };
  video?: {
    asset: {
      url: string;
    };
  };
  showInlineOnMobile?: boolean;
}
const ProductMedia = ({ data }: { data: ProductMedia }) => {
  if (data.video?.asset?.url) {
    return (
      <div className={styles.videoContainer}>
        <video
          autoPlay
          muted
          loop
          playsInline
          controls={false}
          poster={data.image?.asset?.url}
          preload="auto"
        >
          <source src={data.video.asset.url} type="video/mp4" />
          {data.image?.asset._id && (
            <Image
              key={data._key}
              className={styles.productImage}
              imageId={data.image.asset._id}
              alt={data.alt}
            />
          )}
        </video>
      </div>
    );
  } else if (data.image?.asset?._id) {
    return (
      <Image
        key={data._key}
        className={styles.productImage}
        imageId={data.image.asset._id}
        alt={data.alt}
      />
    );
  } else {
    return null;
  }
};

interface ProductContentModuleProps {
  section: {
    images: [ProductMedia];
    sharedCopy?: {
      title: string;
      body: [];
    };
    title?: string;
    copy?: [];
    enableNavigationLink?: boolean;
    navigationLinkTitle?: string;
  };
}

export const ProductContentModule = ({
  section,
}: ProductContentModuleProps) => {
  const {
    images,
    sharedCopy,
    title,
    copy,
    enableNavigationLink,
    navigationLinkTitle,
  } = section;
  return (
    <ScrollElement
      className={styles.contentModule}
      name={
        enableNavigationLink && navigationLinkTitle ? navigationLinkTitle : ""
      }
    >
      <div className={cx("hide-max-medium", styles.imageColumn)}>
        {images &&
          images.map((image) => {
            return <ProductMedia data={image} />;
          })}
      </div>
      <div className={styles.copyColumn}>
        <div className={styles.copyColumnInner}>
          {sharedCopy && sharedCopy.body && (
            <BlockCopy className={styles.copy} copy={sharedCopy.body} />
          )}
          {copy && <BlockCopy className={styles.copy} copy={copy} />}
        </div>
        {images &&
          images.map((productImage) => {
            if (productImage.showInlineOnMobile) {
              return (
                <Image
                  key={productImage._key}
                  className={cx("hide-min-large", styles.inlineProductImage)}
                  imageId={productImage.image?.asset._id}
                  alt={productImage.image?.alt}
                />
              );
            }
          })}
      </div>
    </ScrollElement>
  );
};
